import { createFileRoute, redirect } from '@tanstack/react-router';
import { APP_ROUTES } from '@/const/routes';

export const Route = createFileRoute('/app/settings/')({
  beforeLoad: () => {
    throw redirect({ to: APP_ROUTES.app.settings.company });
  },
});
